import { API_URL } from '../utils/api';

class UserApis {
  constructor(userId, storeId) {
    this.userId = userId;
    this.storeId = storeId;
  }

  // Get store information
  async getStore() {
    try {
      const url = `${API_URL}/store/${this.storeId}`;
      console.log('UserApis: Making request to:', url);
      console.log('UserApis: Store ID:', this.storeId);
      
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      console.log('UserApis: Response status:', response.status);
      console.log('UserApis: Response ok:', response.ok);

      if (response.ok) {
        const data = await response.json();
        console.log('UserApis: Response data:', data);
        return data.types || {};
      } else {
        const error = await response.json();
        console.error('UserApis: Error response:', error);
        return {};
      }
    } catch (error) {
      console.error('UserApis: Network error:', error);
      return {};
    }
  }

  // Get user information
  async getUser() {
    try {
      const response = await fetch(`${API_URL}/users/${this.userId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        const data = await response.json();
        return data.user || {};
      } else {
        const error = await response.json();
        console.error('Error fetching user:', error);
        return {};
      }
    } catch (error) {
      console.error('Error fetching user:', error);
      return {};
    }
  }

  // Get store inputs
  async getStoreInputs() {
    try {
      const response = await fetch(`${API_URL}/store/${this.storeId}/inputs`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        const data = await response.json();
        return data.inputs || [];
      } else {
        const error = await response.json();
        console.error('Error fetching store inputs:', error);
        return [];
      }
    } catch (error) {
      console.error('Error fetching store inputs:', error);
      return [];
    }
  }

  // Update user profile
  async updateProfile(userData) {
    try {
      const response = await fetch(`${API_URL}/users/${this.userId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(userData),
      });

      if (response.ok) {
        const data = await response.json();
        return data.user;
      } else {
        const error = await response.json();
        console.error('Error updating user profile:', error);
        throw new Error(error.message || 'Failed to update profile');
      }
    } catch (error) {
      console.error('Error updating user profile:', error);
      throw error;
    }
  }
}

export default UserApis; 